import { Icon } from "@iconify/react/dist/iconify.js";

export default function ValueItem({ label, onDelete }) {
  return (
    <div className="hitq-panel-value">
      <span>{label}</span>
      <Icon
        color="red"
        className="flex-shrink-0"
        icon="iconoir:cancel"
        width="24"
        height="24"
        role="button"
        onClick={onDelete}
      />
    </div>
  );
}
